<template>
  <section>
    <v-container fluid>
      <v-row class="justify-end align-center">
        <v-col cols="auto" class="ml-auto">
          <v-text-field
            filled
            rounded
            dense
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="shadow-1">
      <!-- NO TOCAR. ESTA PAGINACIÓN POR SERVIDOR SI FUNCIONA -->
      <v-data-table
        :headers="headers"
        :items="assistanceList"
        :search="search"
        :loading="isLoading"
        :options.sync="options"
        :server-items-length="totalItems"
        :footer-props="{
          'items-per-page-options': [15, 30, 50, 100],
        }"
      >
        <template v-slot:[`item.name`]="{ item }">
          <v-list two-line max-width="350px" class="transparent my-0 py-0">
            <v-list-item class="px-0">
              <v-list-item-content class="d-block d-md-none mr-2">
                <v-list-item-title
                  class="primary--text text--darken-1 font-weight-medium"
                  v-html="item.name"
                ></v-list-item-title>
                <v-list-item-subtitle
                  v-html="item.email"
                ></v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-avatar size="40" tile>
                <v-avatar
                  size="40"
                  :color="
                    $vuetify.theme.dark
                      ? 'blue-grey darken-4'
                      : 'blue-grey lighten-5'
                  "
                >
                  <v-img
                    v-if="item.url_image"
                    :src="item.url_image"
                    alt="Avatar del usuario"
                  ></v-img>
                  <v-icon color="blue-grey" v-else>mdi-account</v-icon>
                </v-avatar>
              </v-list-item-avatar>

              <v-list-item-content class="d-none d-md-block ml-3">
                <v-list-item-title
                  class="primary--text text--darken-1 font-weight-medium"
                  v-html="item.name"
                ></v-list-item-title>
                <v-list-item-subtitle
                  v-html="item.email"
                ></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </template>

        <template v-slot:[`item.id`]="{ item }">
          <span v-if="item.assistance.length > 0">
            {{ item.assistance[0].hours_worked }}
          </span>
        </template>

        <template v-slot:[`item.status`]="{ item }">
          <v-tooltip color="blue-grey" top>
            <template v-slot:activator="{ on }">
              <v-chip
                v-on="on"
                color="transparent"
                small
                @click="changeStatus(item)"
              >
                <v-icon left small :color="statusColor(item.status)"
                  >mdi-radiobox-marked</v-icon
                >
                {{ item.status | StatusName }}
              </v-chip>
            </template>
            <span>Cambiar estado</span>
          </v-tooltip>
        </template>

        <template v-slot:[`item.sesion`]="{ item }">
          <v-chip
            v-if="
              item.assistance[0].created_at !== item.assistance[0].updated_at &&
                item.status !== 2
            "
            color="transparent"
            small
          >
            <v-icon left color="grey">
              mdi-circle-medium
            </v-icon>
            Desconectado
          </v-chip>

          <v-chip v-else color="transparent" small>
            <v-icon left color="success">
              mdi-circle-medium
            </v-icon>
            En línea
          </v-chip>
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <v-tooltip
            top
            color="blue-grey"
            v-if="
              item.assistance[0].created_at == item.assistance[0].updated_at &&
                item.status !== 2
            "
          >
            <template v-slot:activator="{ on }">
              <v-hover v-slot:default="{ hover }">
                <v-btn
                  v-on="on"
                  v-show="item.status !== 2"
                  text
                  icon
                  :color="hover ? 'accent' : 'blue-grey'"
                  @click.stop="logoutAgent(item)"
                >
                  <v-icon>mdi-logout</v-icon>
                </v-btn>
              </v-hover>
            </template>
            <span>Cerrar sesión</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>

    <!-- <v-row justify="end">
            <v-col cols="auto">
                <v-pagination
                    v-if="!isLoading && assistanceList.length > 0"
                    circle
                    color="primary"
                    v-model="page"
                    :length="pageCount"
                ></v-pagination>
            </v-col>
        </v-row> -->
  </section>
</template>
<script>
export default {
  data() {
    return {
      isLoading: false,
      // For pagination
      totalItems: 0,
      options: {
        page: 1,
        itemsPerPage: 15,
      },
      // End for pagination
      search: "",
      headers: [
        {
          text: "Nombre",
          value: "name",
          class: "primary--text",
          width: "35%",
        },
        {
          text: "Horas Trabajadas",
          value: "id",
          class: "primary--text",
          width: "20%",
        },
        {
          text: "Estado",
          value: "status",
          class: "primary--text",
          width: "25%",
        },
        {
          text: "Sesión",
          value: "sesion",
          class: "primary--text",
          width: "25%",
        },
        {
          text: "Acciones",
          value: "action",
          class: "primary--text",
          width: "20%",
          align: "center",
          sortable: false,
        },
      ],
    };
  },

  computed: {
    assistanceList() {
      return this.$store.getters["assistance/GET_ASSISTANCE_AGENT"];
    },
  },

  created() {
    this.assistanceGet();
  },

  watch: {
    options: {
      handler() {
        this.assistanceGet();
      },
      deep: true,
    },
  },

  methods: {
    /**
     * Fetch Assistance List
     */
    async assistanceGet() {
      this.isLoading = true;

      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      const payload = {
        page,
        itemsPerPage,
      };

      try {
        const res = await this.$store.dispatch("assistance/GET", payload);
        // this.pageCount = res.last_page;
        // this.itemsPerPage = res.per_page;
        this.totalItems = res.total;
      } catch (error) {
        this.$snotify.error("Hubo un error en la consulta.", "Error");
        // console.error(error);
      }
      this.isLoading = false;
    },

    async logoutAgent(agent) {
      try {
        const indexdelete = this.assistanceList.indexOf(agent);
        // console.log(indexdelete,'yson');
        const payload = {
          agent_id: agent.id,
          agent_index: indexdelete,
        };
        const response = await this.$store.dispatch(
          "assistance/REMOVE_AGENT",
          payload
        );
        this.$snotify.success(`Sesión de ${agent.name} finalizada`, "¡Hecho!");
      } catch (error) {
        this.$snotify.error("No se pudo finalizar la sesión.", "¡Error!");
        // console.error(error, "assistance error");
      }
    },

    statusColor(status) {
      let color;

      switch (status) {
        case 0:
          color = "error";

          break;

        case 1:
          color = "success";

          break;

        case 2:
          color = "light-blue";

          break;

        case 3:
          color = "warning";

          break;
      }
      return color;
    },

    async changeStatus(value) {
      // console.log("Prueba", value);
      const conf = confirm("Eliminar pausa?");
      if (conf) {
        try {
          if (value.status === 2) {
            await this.$store.dispatch("user/QUIT_PAUSE", {
              id: value.user_pause[0].id,
            });
          }
          // else {
          //     await this.$store.dispatch("user/CHANGE_STATUS", {
          //         id: value.id
          //     });
          // }

          this.$snotify.success("Estatus cambiado con éxito.", "¡Hecho!");

          this.assistanceGet();
        } catch (error) {
          this.$snotify.error(
            "No se pudo cambiar el estado del usuario.",
            "¡Error!"
          );
          console.error(error);
        }
      }
    },
  },
};
</script>
<style></style>
